import React from "react"
import PropTypes from "prop-types"

const Audio = ({ url }) => {
  return (
    <audio controls style={{ width: "100%" }}>
      <source src={url} />
    </audio>
  )
}

Audio.propTypes = {
  url: PropTypes.string.isRequired,
}

export { Audio }
